<template>
  <div>
    <v-card outlined elevation="0" class="rounded-lg ma-4" tile>
      <v-sheet :class="showVacances ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="py-2 card-title-height">
          <v-btn icon @click="card()">
            <v-icon color="white">
              {{
                showVacances ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <span class="text-body-1 white--text">Commandes Vacances</span>
          <v-spacer />
          <v-select
            v-model="filterByIresaId"
            :items="customerIresaIDs"
            item-text="label"
            item-value="iresaId"
            dense
            flat
            solo
            hide-details
            placeholder="Recherche par iresa id"
            class="pr-12"
            style="max-width: 300px"
            clearable
            @input="searchOrders()"
          />
          <v-btn v-if="!!customer.sso_id && canAddBooking()" elevation="0" icon @click="addBooking()">
            <v-icon color="white" class="pr-1">mdi-plus-thick</v-icon>
          </v-btn>
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showVacances" class="grey lighten-4">
          <v-divider />
          <div class="">
            <v-data-table
              :headers="headers"
              fixed-header
              height="300"
              :items="search.results.items"
              :server-items-length="search.results.count"
              :loading="search.loading"
              :options.sync="options"
              :footer-props="{
                itemsPerPageOptions: itemsPerPageOptions
              }"
              :hide-default-footer="hideFooter"
              loading-text="Loading... Please wait"
              class="elevation-1"
              @update:page="searchOrders()"
              @update:items-per-page="searchOrders()"
            >
              <template #item.number="{ item }">
                {{ item.bookingNumber }}
              </template>

              <template #item.iresa_status="{ item }">
                {{ item.status }}
              </template>

              <template #item.status="{ item }">
                {{ orderStatus(item) }}
              </template>

              <template #item.version="{ item }">
                {{ item.version }}
              </template>

              <template #item.price="{ item }">
                {{ item.price }} €
              </template>

              <template #item.date_depart="{ item }">
                {{ item.startDate }}
              </template>

              <template #item.place="{ item }">
                {{ item.center_destination_name ? item.center_destination_name : item.productGeography }}
              </template>

              <template #item.product="{ item }">
                {{ item.mainProduct }}
              </template>

              <template #item.context="{ item }">
                {{ item.partner }} [{{ item.customerIresaId }}]
              </template>

              <template #item.balance="{ item }">
                N/A <!-- {{ balance(item.price, item.paid) }} -->
              </template>
            </v-data-table>
          </div>
        </div>
      </v-expand-transition>
    </v-card>

    <AddBooking :customer="customer" />
  </div>
</template>

<script>
import { requests } from '@/mixins';
import { EventBus } from '../../mixins';
import AddBooking from '@/components/profile/AddBooking';

export default {
  components: { AddBooking },
  mixins: [requests],
  props: { customer: Object },
  data () {
    return {
      filterByIresaId: null,
      search: {
        abortController: null,
        loading: false,
        results: { items: [], count: 0 }
      },
      options: { itemsPerPage: 50 },
      itemsPerPageOptions: [50, 100, 200],
      headers: [
        { text: 'Nº', value: 'number', sortable: false },
        { text: 'Statut', value: 'status', sortable: false },
        // { text: 'Canal', value: 'canal', sortable: false },
        // { text: 'Payeur', value: 'buyer' }, // it's in mockup but doesn't make sense, since the list only displays orders that the user bought
        { text: 'Iresa Statut', value: 'iresa_status', sortable: false },
        // { text: 'Iresa Version', value: 'version', sortable: false },
        // { text: 'Date création', value: 'date', sortable: false },
        { text: 'Date départ', value: 'date_depart', sortable: false },
        // { text: 'Lieu', value: 'place', sortable: false },
        { text: 'Produit principal', value: 'product', sortable: false },
        { text: 'Context', value: 'context', sortable: false },
        { text: 'Total', value: 'price', sortable: false },
        { text: 'Solde', value: 'balance', sortable: false }
      ],
      showVacances: true
    };
  },
  computed: {
    customerIresaIDs () {
      return this.customer.iresa_ids.map(id => ({
        iresaId: id.iresa_id,
        label: id.extraContextInfo ? `${id.iresa_id} - ${id.extraContextInfo.name}` : `${id.iresa_id} - ${id.context}`
      }));
    },
    hideFooter () {
      const totalItems = (this.search.results.count) || 0;
      const minItemsPerPage = Math.min(...this.itemsPerPageOptions);
      return totalItems <= minItemsPerPage;
    }
  },
  created () {
    this.searchOrders();
  },
  methods: {
    canAddBooking () {
      return this.$store.state.user.roles.includes('admin');
    },
    addBooking () {
      EventBus.$emit('startAddBooking');
    },
    orderStatus (item) {
      if (item.status === 'Option') {
        return 'Option';
      }
      return 'N/A';
      // return item.paymentDetails && !item.paymentDetails.solde ? 'Paid' : 'Not paid';
    },
    balance (price, paid) {
      if (price === undefined || paid === undefined) return ''; // Temporary fix waiting by the Iresa response been enriched
      return `${parseFloat((price - paid).toFixed(2))}€`;
    },
    card () {
      this.showVacances = !this.showVacances;
    },
    async searchOrders () {
      const { page, itemsPerPage } = this.options;
      this.search.loading = true;

      if (this.search.abortController) {
        this.search.abortController.abort();
      }

      this.search.abortController = new AbortController();

      const start = (page - 1) * itemsPerPage || 0;
      const limit = itemsPerPage;

      const source = this.$store.getters.getBrand === 'crm' ? 'speedboat' : 'labalaguere';
      const customerIresaIds = [];

      if (this.filterByIresaId) {
        customerIresaIds.push(this.filterByIresaId);
      } else {
        (this.customer.iresa_ids || []).forEach(id => {
          if (!customerIresaIds.includes(id.iresa_id)) customerIresaIds.push(id.iresa_id);
        });
      }

      if (customerIresaIds.length) {
        const responseOrders = await this.getIresaOrders(customerIresaIds, start, limit);

        if (responseOrders.success) {
          if (source === 'labalaguere') { responseOrders.data.items = responseOrders.data.items.filter(order => order.status !== 'Annulé'); }
          this.search.results = responseOrders.data;
        }
      }

      this.search.loading = false;
    }
  }
};
</script>

<style>
.v-data-table__empty-wrapper {
  height: 250px;
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: center;
  left: 0;
  right: 0;
  margin: auto;
}
.v-data-table__empty-wrapper td {
  font-size: 1.2rem !important;
  }
  </style>
